import Vehicle from './Vehicle';
import type { Vehicle as VehicleModel } from '../models/vehicle';

interface VehicleModuleProps {
  vehicle: VehicleModel | undefined;
}

export default function VehicleModule({ vehicle }: VehicleModuleProps) {
  return <Vehicle vehicleType="other" vehicle={vehicle} />;
}
